export default __webpack_public_path__ + "static/media/captureImgOff.e03dc724.svg";